/* @flow weak */

'use strict';

const Reflux = require('reflux');
const _ = require('lodash');

const PaymentPlanActions = require('../actions/PaymentPlanActions.jsx');
const ProductStore = require('../stores/ProductStore.jsx');

const Config = require('../configs/Config.js');
const Loader = require('../loaders');

const PaymentPlanStore = Reflux.createStore({
  listenables: [PaymentPlanActions],

  paymentPlan: {
    available: false,
    active: false
  },

  getInitialState() {
    return this.paymentPlan;
  },

  onSetAvailability(flag) {
    this.paymentPlan.available = !!flag;
    this.trigger(this.paymentPlan);
  },

  getIsAvailable() {
    return this.paymentPlan.available;
  },

  onSetActive(flag, initialSet = false) {
    this.paymentPlan.active = !!flag;
    this.trigger(this.paymentPlan);

    const trackingTarget = _.get(window, Config.analytics.eventTrackingTarget);

    if (!!flag &&
      !initialSet &&
      Config.analytics.enableTracking &&
      trackingTarget &&
      typeof trackingTarget === 'function')
    {
      const event = 'uc_partialPayments';
      const category = _.get(Config, 'analytics.eventCategory');
      const action = 'Payment Plan Selected';
      const label = _.get(location, 'href');      

      trackingTarget(event, category, action, label);
    }
  },

  getIsActive() {
    return this.paymentPlan.active;
  }
});

module.exports = PaymentPlanStore;


// WEBPACK FOOTER //
// ./src/base/scripts/stores/PaymentPlanStore.jsx